( function () {
    'use strict';
    /**
     * @namespace
     */
    master.ecom = {
        /**
         * Utils
         * @namespace
         */
        utils: {
            /** @function */
            /**
             * Update price animation
             * @deprecated

             */
            priceUpdate: function () {
                jQuery( '.js-e-price' ).on( 'DOMSubtreeModified', function () {
                    var jParent = jQuery( this ).parent();
                    jParent.addClass( 'master-webshop-and-service-details-price--animate' );
                    jParent.one( master.settings.animationEnd, function () {
                        jParent.removeClass( 'master-webshop-and-service-details-price--animate' );
                    } );
                } );
            },
            /** @function */
            /**
             * Back link logic from session store

             */
            backLink: function () {
                jQuery( '.js-webshop-grid' ).on( 'click', 'a', function () {
                    var pid = jQuery( this ).parents( 'li' ).find( 'a[name^="e-pidlink-"]' );
                    if ( pid ) {
                        sessionStorage.setItem( 'pidlink', pid.attr( 'name' ) );
                    }
                } );
                if ( jQuery( '.js-back-btn' ).length ) {
                    var jUrl = location.href.split( '?' )[ 0 ],
                        jRef = document.referrer.split( '?' )[ 0 ];
                    if ( jUrl !== jRef ) {
                        master.store.session.set( 'productlist-history', jRef );
                    }
                    if ( sessionStorage.getItem( 'productlist-history' ) !== '' ) {
                        jQuery( '.js-back-btn' ).attr( 'href', sessionStorage.getItem( 'productlist-history' ) );
                    }
                    else {
                        jQuery( '.js-back-btn' ).attr( 'href', jRef );
                    }
                }
                if ( jQuery( '.js-webshop-grid' ).length && sessionStorage.getItem( 'pidlink' ) !== null && !jQuery( '.js-back-btn' ).length ) {
                    co3.util.scroll.toElement( jQuery( 'a[name="' + sessionStorage.getItem( 'pidlink' ) + '"]' ), 0, true, true );
                    sessionStorage.removeItem( 'pidlink' );
                }
            },
            init: function () {
                this.priceUpdate();
                this.backLink();
            }
        },
        /** @function */
        /**
         * Check services in cart

         */
        serviceInCart: function () {
            jQuery( '.js-cart-contains-serviceitems-check' ).on( 'click', function ( event ) {
                event.preventDefault();
                jQuery( '.js-webshop-context-modal' ).modal();
            } );
        },
        /** @function */
        /**
         * Disable add-to-cart
         */
        disabledAddToCart: function () {
            jQuery( '.js-add-to-cart-button ' ).on( 'click', function ( event ) {
                if ( jQuery( this ).is( '.disabled' ) ) {
                    event.preventDefault();
                    co3.util.scroll.toElement( jQuery( 'body' ), 0, true, true );
                    jQuery( '.js-validation-panel' ).find( '.js-validation-panel-icon' ).addClass( 'attention' ).one( master.settings.animationEnd, function () {
                        jQuery( this ).removeClass( 'attention' );
                    } );
                }
            } );
        },
        /** @function */
        /**
         * Add webshop item to cart
         * @deprecated
         */
        addWebshopItemToCart: function () {
            jQuery( '.js-cart-contains-serviceitems-check' ).closest( 'form' ).submit();
        },
        /** @function */
        /**
         * Product details tabs
         */
        producttabs: function () {
            jQuery( '.tabbable ul li' ).first().addClass( 'active' );
            jQuery( '.tabbable .tab-content .tab-pane' ).first().addClass( 'active' );
        },
        /** @function */
        /**
         * Toggle time of day

         */
        order: function () {
            jQuery( '#deliveryForm' ).find( '.required' ).prop( 'checked', false );
            jQuery( 'input[type="radio"][disabled]' ).parent( 'label' ).addClass( 'disabled' );
            jQuery( '.time-of-day' ).on( 'click', 'input[type="radio"]', function () {
                jQuery( 'input[type="radio"]:checked' ).parent( 'label' ).addClass( 'active' );
                jQuery( 'input[type="radio"]:unchecked' ).parent( 'label' ).removeClass( 'active' );
            } );
        },
        /**
         * Ecommerce Price matrix (not in use)
         * @namespace
         * @property {HtmlFormElement} formElement
         * @property {Array} values
         * @property {Boolean} updateQuantity
         * @deprecated
         */
        priceMatrix: {
            formElement: jQuery( '.js-price-matrix-form' ),
            values: [],
            updateQuantity: true,
            update: function ( jThisFormRadioChecked ) {
                var jQuantity = this.formElement.find( 'input[name="Quantity"]' ),
                    jMatrixQuantity = jThisFormRadioChecked.data( 'product-quantity' );
                this.formElement.find( '.js-e-price' ).html( jThisFormRadioChecked.val() );
                this.formElement.find( '.js-price-matrix-amount' ).html( jMatrixQuantity );
                this.formElement.find( 'input[name="matrixItem"]' ).parents( 'tr' ).removeClass( 'active-row' );
                jThisFormRadioChecked.parents( 'tr' ).addClass( 'active-row' );
                if ( parseInt( jMatrixQuantity ) !== parseInt( jQuantity.val() ) && this.updateQuantity === true ) {
                    jQuantity.val( co3.util.formatNumberToJavascript( jMatrixQuantity ) ).trigger( 'change' );
                }
            },
            items: function () {
                var that = this,
                    jThisFormRadioChecked = '';
                that.formElement.find( '.js-price-matrix-item input[name="matrixItem"]' ).each( function () {
                    that.values.push( jQuery( this ).data( 'product-quantity' ) );
                } );
                that.formElement.find( '.js-price-matrix-item' ).on( 'click', function () {
                    jQuery( this ).find( 'input[name="matrixItem"]' ).prop( 'checked', true ).trigger( 'change' );
                } );
                that.formElement.find( '.js-price-matrix-item input[name="matrixItem"]' ).on( 'change click', function () {
                    jThisFormRadioChecked = that.formElement.find( 'input[name="matrixItem"]' ).filter( ':checked' );
                    that.update( jThisFormRadioChecked );
                } );
            },
            quantity: function () {
                var that = this,
                    jThisFormRadioChecked = '';
                that.formElement.find( 'input[name="Quantity"]' ).on( 'keyup change', function () {
                    var quantityValue = parseInt( jQuery( this ).val() );
                    if ( that.formElement.find( '.js-price-matrix-table' ).length ) {
                        jThisFormRadioChecked = that.formElement.find( 'input[name="matrixItem"]' ).filter( ':checked' );
                        var jMatrixValues = that.values;
                        for ( var i = 0; i < jMatrixValues.length; i++ ) {
                            if ( quantityValue <= jMatrixValues.length ) {
                                that.updateQuantity = true;
                                if ( quantityValue === jMatrixValues[ i ] ) {
                                    that.formElement.find( 'input[name="matrixItem"][data-product-quantity="' + quantityValue + '"]' ).trigger( 'click' );
                                }
                                else if ( quantityValue > jMatrixValues[ i ] && quantityValue <= ( jMatrixValues[ i ] + 1 ) ) {
                                    jThisFormRadioChecked.parents( 'tr' ).next().find( 'input[name="matrixItem"]' ).trigger( 'click' );
                                }
                                return false;
                            }
                            else {
                                that.updateQuantity = false;
                                that.formElement.find( 'tr[data-row-count="' + jMatrixValues.length + '"]' ).end().find( 'input[name="matrixItem"]' ).trigger( 'click' );
                                return false;
                            }
                        }
                    }
                } );
            },
            init: function () {
                this.items();
                this.quantity();
            }
        },
        /**
         * Webshop cart stock
         * @namespace

         * @deprecated since version 2.0
         */
        cartStock: {
            orderlines: 0,
            inStock: [],
            stdText: '',
            msg: function () {
                function isTrue( element ) {
                    return element === true;
                }
                if ( master.ecom.cartStock.inStock.every( isTrue ) === true ) {
                    //console.log( true );
                    jQuery( '.js-e-orderline' ).find( '.stock-status .stockText' ).text( master.ecom.cartStock.stdText );
                }
                else {
                    //console.log( false );
                    jQuery( '.js-e-orderline' ).find( '.stock-status .stockText' ).text( 'Du modtager en sms, når varen kan afhentes på værkstedet' );
                }
            }
        },
        checkStock: function ( context, jDepartment ) {
            var jThis = this;
            if ( context === 'cart' ) {
                jQuery( '.js-e-orderline' ).each( function () {
                    var jStock = jQuery( this ).find( '.stock-status' ),
                        jProdID = jQuery( this ).data( 'product-id' );
                    jThis.fetchStock( jDepartment, jStock, jProdID, context, jQuery( this ) );
                } );
            }
            else if ( context === 'details' ) {
                var jStock = jQuery( '.e-productdetails-action' ).find( '.stock-status' ),
                    jProdID = jQuery( '.js-stock-check' ).data( 'prodnr' );
                jStock.find( '.js-stock' ).hide();
                jThis.fetchStock( jDepartment, jStock, jProdID, context );
            }
            else if ( context === 'list' ) {
                jQuery( '.js-webshop-grid' ).find( '.js-webshop-grid-item:not(.stock-fetched)' ).each( function () {
                    var jStock = jQuery( this ).find( '.js-stock-status' ),
                        jProdID = jStock.data( 'prodnr' );
                    jQuery( this ).addClass( 'stock-fetched' );
                    jThis.fetchStock( jDepartment, jStock, jProdID, context );
                } );
            }
        },
        fetchStock: function ( jDepartment, jStock, jProdID, context, jRow ) {
            jQuery.ajax( {
                url: master.data.orderHandler.endpoint,
                type: 'POST',
                data: {
                    action: master.data.orderHandler.actions.getstockdetail,
                    productnumber: jProdID,
                    departmentid: jDepartment
                },
            } ).done( function ( data ) {
                if ( context === 'cart' ) {
                    master.ecom.cartStock.stdText = data.Data.Text;
                    if ( parseInt( data.Data.Afd ) > 0 && parseInt( data.Data.Total ) > 0 ) {
                        jRow.find( '.js-stock-check-spinner' ).fadeOut( master.settings.animateSpeed, function () {
                            jRow.find( '.js-stock-in' ).show();
                            //jRow.find( '.js-stock-in.stock-msg' ).show().find( '.stockText' ).text( data.Data.Text );
                        } );
                        master.ecom.cartStock.inStock.push( true );
                    }
                    else if ( parseInt( data.Data.Afd ) === 0 && parseInt( data.Data.Total ) > 0 ) {
                        jRow.find( '.js-stock-check-spinner' ).fadeOut( master.settings.animateSpeed, function () {
                            jRow.find( '.js-stock-in' ).show();
                            //jRow.find( '.js-stock-in.stock-msg' ).show().find( '.stockText' ).text( 'Levering indenfor 24 timer ved bestilling inden kl. 24.' );
                        } );
                        master.ecom.cartStock.inStock.push( true );
                    }
                    else if ( parseInt( data.Data.Afd ) === 0 && parseInt( data.Data.Total ) <= 0 ) {
                        jRow.find( '.js-stock-check-spinner' ).fadeOut( master.settings.animateSpeed, function () {
                            jRow.find( '.js-stock-out' ).show();
                            //jRow.find( '.js-stock-out.stock-msg' ).show().find( '.stockText' ).text( '' );
                        } );
                        master.ecom.cartStock.inStock.push( false );
                    }
                    master.ecom.cartStock.orderlines++;
                    if ( master.ecom.cartStock.orderlines === jQuery( '.js-e-orderline' ).length ) {
                        master.ecom.cartStock.msg();
                    }
                }
                else if ( context === 'details' ) {
                    if ( parseInt( data.Data.Total ) > 0 ) {
                        jStock.find( '.js-stock-check-spinner' ).fadeOut( master.settings.animateSpeed, function () {
                            jStock.find( '.js-stock-in' ).fadeIn();
                            jStock.find( '.js-stock-in.stock-msg' ).fadeIn().find( '.stockText' ).text( 'Levering indenfor 4 timer på lokal værksted ved bestilling inden kl. 12.00' );
                        } );
                    }
                    else {
                        jStock.find( '.js-stock-check-spinner' ).fadeOut( master.settings.animateSpeed, function () {
                            jStock.find( '.js-stock-out' ).show();
                            jStock.find( '.js-stock-out.stock-msg' ).hide().find( '.stockText' ).text( '' );
                        } );
                    }
                }
                else if ( context === 'list' ) {
                    if ( parseInt( data.Data.Total ) > 0 ) {
                        jStock.find( '.js-checking-stock-status' ).fadeOut( master.settings.animateSpeed, function () {
                            jStock.find( '.js-stock-in' ).fadeIn( master.settings.animateSpeed );
                        } );
                    }
                    else {
                        jStock.find( '.js-checking-stock-status' ).fadeOut( master.settings.animateSpeed, function () {
                            jStock.find( '.js-stock-out' ).fadeIn( master.settings.animateSpeed );
                        } );
                    }
                }
            } );
        },
        setProductNameInGetPriceForm: function () {
            if ( jQuery( '#js-ecom-product-name' ).length > 0 ) {
                var productName = jQuery( '#js-ecom-product-name' ).val().trim();
                jQuery( 'input[name="ProductName"]' ).val( productName );
            }
        },
        init: function () {
            this.utils.init();
            this.priceMatrix.init();
            this.producttabs();
            this.disabledAddToCart();
            this.serviceInCart();
            this.order();
            this.setProductNameInGetPriceForm();
            if ( jQuery( '.js-stock-webshop-details' ).length ) {
                this.checkStock( 'details', 38 );
            }
            else if ( jQuery( '.js-webshop-grid' ).length ) {
                this.checkStock( 'list', 38 );
            }
            else if ( jQuery( '.js-e-checkout-form-cart, .js-master-checkout' ).length ) {
                this.checkStock( 'cart', 38 );
            }
        }
    };
}() );
